import React, { useCallback, useEffect, useState } from "react"
import { useHistory } from "react-router"
import moment from "moment"
import { getAppointmentById, getAppointmentsByQuery, getCenterDetail } from "../../core/services/api"
import {
  fetchRooms,
  bookBed,
  bookbedbyId,
} from "../../core/services/api/bedManagementService"
import "./BedAllocationRequest.scss"
import Toast from "../../components/Toast"
import { useSelector } from "react-redux"
import AllocationRequestCard from "./components/AllocationRequestCard"
import { debounce } from 'lodash';

export default function BedAllocationRequest({ location }: any) {
  const history = useHistory()
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  const [allRooms, updateAllRooms] = useState<any>([])

  const [appointments, updateAppointments] = useState<any>([])

  const [displayToast, toggleDisplayToast] = useState<any>()
  const [rooms, updateRooms] = useState<any>()

  const [selectedItem, updateSelectedItem] = useState<any>()
  const [bedSlotDuration, setBedSlotDuration] = useState<any>()

  useEffect(() => {

    if (location?.search) {
      const appointmentId = new URLSearchParams(location.search).get("appointmentId")
      console.log(appointmentId, "appointmentId")
      if (appointmentId) {
        getAppointmentById(appointmentId).then((res) => {
          updateAppointments([res])
        })
      }
      else {
        fetchPendingRequests()
      }
    }
    else {
      fetchPendingRequests()
    }
  }, [location])

  console.log("rooms", rooms)

  useEffect(() => {
    fetchRooms(userDetail?.currentCenter?.centerId)
      .then((res: any) => updateAllRooms(res))
      .catch((err: any) => console.log("err in room fetch", err))
  }, [])

  function fetchPendingRequests() {
    let query = `centerId=${userDetail?.currentCenter?.centerId
      }&appointmentType=IPD&status=WAITING_FOR_APPROVAL&startDate=${moment().format(
        "YYYY-MM-DD"
      )}`
    getAppointmentsByQuery(query)
      .then((res: any) => {
        const temp = res?.filter((itm: any) => !itm?.allottedBed || (itm?.allottedBed?.length === 0))
        updateAppointments(temp)
      })
      .catch((err) => console.log("err in bed req fetch", err))
  }


  useEffect(() => {
    getCenterDetail(userDetail?.currentCenter?.centerId).then((res: any) => {
      setBedSlotDuration(res?.bedSlotDuration)
    })
  }, [])

  function onBedBook(body: any) {
    // bed booking api
    let count = 0;
    count = isConsecutiveSlot(body?.bookedSlots, bedSlotDuration);
    console.log('location', location);

    if (count === 0) {
      const appointmentId = new URLSearchParams(location.search).get("appointmentId");

      if (appointmentId) {
        let tempBody: any = {};
        console.log('body', body);
        tempBody["bedId"] = body?.bedId;
        tempBody["roomId"] = body?.roomId;
        tempBody["bedBookingStatus"] = "BOOKED";
        tempBody["bedIsVacant"] = false;

        let bookedSlots = [].concat(location?.state?.bookedSlots);
        bookedSlots = bookedSlots.concat(body?.bookedSlots);
        tempBody["bookedSlots"] = bookedSlots;

        let tempC = 0;
        tempC = isConsecutiveSlot(bookedSlots, bedSlotDuration);

        if (tempC === 0) {
          debounceBookBedById(location?.state?.id, tempBody);
        } else {
          toggleDisplayToast({
            text: "Please select consecutive time slots to proceed",
            type: "error",
          });
        }
      } else {
        debounceBookBed(body);
      }
    } else {
      toggleDisplayToast({
        text: "Please select consecutive time slots to proceed",
        type: "error",
      });
      return;
    }
  }

  // Debounced bookBedById function
  const debounceBookBedById = useCallback(
    debounce((id: any, body: any) => {
      bookbedbyId(id, body).then((res) => {
        console.log(res, "nnn");
        toggleDisplayToast({
          text: "Room and bed has been Edited successfully",
          type: "success",
        });
      }).catch((err) => {
        console.log(err, "Error in editing bed");
      });
    }, 300), // Adjust the debounce delay (300ms in this case)
    []
  );

  // Debounced bookBed function
  const debounceBookBed = useCallback(
    debounce((body: any) => {
      bookBed(body)
        .then((res: any) => {
          console.log("res in book bed", res);
          toggleDisplayToast({
            text: "Room and bed has been booked successfully",
            type: "success",
          });
          fetchPendingRequests(); // Call the API after booking bed
        })
        .catch((err) => {
          console.log("err", err);
          toggleDisplayToast({
            text: err?.response?.data?.message
              ? err?.response?.data?.message
              : "Unable to book beds",
            type: "error",
          });
        });
    }, 300),
    []
  );

  function isConsecutiveSlot(slots: any, diff: any) {
    let count = 0
    slots?.sort(function (a: any, b: any) {
      return a < b ? -1 : 1
    })
    for (var i = 1; i < slots?.length; i++) {
      const duration = moment.duration(
        moment(slots[i], "HH:mm").diff(moment(slots[i - 1], "HH:mm"))
      )
      if (duration?.asMinutes() !== diff) {
        count = count + 1
      }
    }
    return count
  }

  console.log('appointments', appointments)

  return (
    <div className="bed-allocation-request">
      <div className="d-flex ">
        <div
          className="allocation-back-image pointer"
          onClick={() => history.goBack()}
        >
          <img
            src="../../assets/images/back-icon.svg"
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
        </div>
        <div className="allocation-request-text">Bed Allocation Requests</div>
      </div>
      <div>
        {appointments?.length > 0 ? appointments?.map((eachAppointment: any) =>
          <AllocationRequestCard
            userRole={userRole}
            eachAppointment={eachAppointment}
            allRooms={allRooms}
            onBedBook={(body: any) => onBedBook(body)}
          />
        ) : <div className="empty-state">No pending requests available</div>}
      </div>

      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          onClose={() => toggleDisplayToast(false)}
          onCloseText="Close"
          onClickText={null}
          type={displayToast?.type}
        />
      )}
    </div>
  )

}
